import type { FunctionComponent } from 'react';
import { Flex } from '@mantine/core';

import { WarningIconSm } from '@chownow/pantry/icons';
import { DisabledReasonTooltip } from './DisabledReasonTooltip';

type PosSyncLockoutIconProps = {
  label: string;
};

export const PosSyncLockoutIcon: FunctionComponent<PosSyncLockoutIconProps> = ({ label }) => (
  <DisabledReasonTooltip label={label}>
    <Flex
      w={16}
      h={16}
      c="var(--content-secondary)"
      style={{ flexShrink: 0 }}
      data-testid="pos-sync-lockout-icon"
    >
      <WarningIconSm />
    </Flex>
  </DisabledReasonTooltip>
);
